import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import PostDetail from "../pages/post/page";
import Privacy from "../pages/privacy/page";
import Terms from "../pages/terms/page";
import Contact from "../pages/contact/page";
import Board from "../pages/board/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/post/:id",
    element: <PostDetail />,
  },
  {
    path: "/board/:category",
    element: <Board />,
  },
  {
    path: "/privacy",
    element: <Privacy />,
  },
  {
    path: "/terms",
    element: <Terms />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
